import { render, staticRenderFns } from "./ChatInputWrap.vue?vue&type=template&id=67a6f282&scoped=true&"
import script from "./ChatInputWrap.vue?vue&type=script&lang=js&"
export * from "./ChatInputWrap.vue?vue&type=script&lang=js&"
import style0 from "./ChatInputWrap.vue?vue&type=style&index=0&id=67a6f282&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a6f282",
  null
  
)

export default component.exports